module.exports = __webpack_public_path__ + "img/day13.81267691.jpeg";